<template>
  <el-card>
    <div class="toolbar">
      <el-input v-model="keyword" placeholder="标题关键字" clearable style="width: 220px" @keyup.enter.native="load" />
      <el-select v-model="statusFilter" clearable placeholder="状态" style="width: 120px" @change="onFilterChange">
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" @click="load">查询</el-button>
      <el-button type="success" @click="openCreate">新增轮播图</el-button>
    </div>
    <el-table :data="rows" border stripe v-loading="loading" style="width: 100%; margin-top: 12px">
      <el-table-column prop="title" label="标题" min-width="180" />
      <el-table-column label="图片" width="170">
        <template slot-scope="s">
          <el-image v-if="s.row.imageUrl" :src="resolveMediaUrl(s.row.imageUrl)" fit="cover" class="thumb" :preview-src-list="[resolveMediaUrl(s.row.imageUrl)]" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="状态" width="90">
        <template slot-scope="s">
          <el-tag :type="s.row.status === 1 ? 'success' : 'info'" size="mini">{{ s.row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="s">
          <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
          <el-button type="text" @click="toggleStatus(s.row)">{{ s.row.status === 1 ? '禁用' : '启用' }}</el-button>
          <el-button type="text" class="danger" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 12px" background layout="total, prev, pager, next" :total="total" :page-size="size" :current-page.sync="page" @current-change="load" />

    <el-dialog :title="dlgTitle" :visible.sync="dlg" width="560px" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="标题" prop="title"><el-input v-model="form.title" maxlength="200" show-word-limit /></el-form-item>
        <el-form-item label="图片" prop="imageUrl">
          <el-upload class="uploader" :action="uploadAction" :headers="uploadHeaders" name="file" :data="{ folder: 'banners' }" :show-file-list="false" accept="image/*" :before-upload="beforeImageUpload" :on-success="onImageSuccess">
            <img v-if="form.imageUrl" :src="resolveMediaUrl(form.imageUrl)" class="preview" />
            <i v-else class="el-icon-plus uploader-icon" />
          </el-upload>
          <p class="hint">建议使用横图，单张不超过 5MB</p>
        </el-form-item>
        <el-form-item label="跳转地址"><el-input v-model="form.jumpUrl" placeholder="可选：小程序路径或 https 地址" maxlength="512" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sortOrder" :min="0" :max="99999" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="form.status"><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dlg = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../api/http';
import { resolveApiBaseUrl } from '../api/apiBase';

export default {
  name: 'BannersView',
  data() {
    return {
      rows: [], keyword: '', statusFilter: null, page: 1, size: 20, total: 0,
      loading: false, dlg: false, dlgMode: 'create', saving: false,
      form: this.emptyForm(),
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        imageUrl: [{ required: true, message: '请上传图片', trigger: 'change' }]
      }
    };
  },
  computed: {
    dlgTitle() { return this.dlgMode === 'create' ? '新增轮播图' : '编辑轮播图'; },
    uploadAction() { return `${resolveApiBaseUrl()}/files/upload`; },
    uploadHeaders() {
      const token = localStorage.getItem('admin_token');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
  },
  mounted() { this.load(); },
  methods: {
    emptyForm() { return { id: null, title: '', imageUrl: '', jumpUrl: '', sortOrder: 0, status: 1, remark: '' }; },
    resolveMediaUrl(value) {
      if (!value) return '';
      const s = String(value).trim();
      if (/^https?:\/\//i.test(s)) return s;
      const base = resolveApiBaseUrl().replace(/\/$/, '');
      let relative = s.replace(/^\/+/, '');
      if (relative.startsWith('api/files/serve/')) relative = relative.substring('api/files/serve/'.length);
      return `${base}/files/serve/${relative}`;
    },
    load() {
      this.loading = true;
      const params = { page: this.page, size: this.size };
      if (this.keyword) params.keyword = this.keyword.trim();
      if (this.statusFilter === 0 || this.statusFilter === 1) params.status = this.statusFilter;
      http.get('/admin/banners', { params }).then(({ data }) => {
        const raw = data.data != null ? data.data : data;
        this.rows = raw.records || [];
        this.total = raw.total || 0;
      }).catch((e) => this.$message.error(e.message || '加载失败')).finally(() => { this.loading = false; });
    },
    onFilterChange() { this.page = 1; this.load(); },
    openCreate() { this.dlgMode = 'create'; this.resetForm(); this.dlg = true; },
    openEdit(row) {
      this.dlgMode = 'edit';
      this.form = { id: row.id, title: row.title || '', imageUrl: row.imageUrl || '', jumpUrl: row.jumpUrl || '', sortOrder: row.sortOrder || 0, status: row.status == null ? 1 : row.status, remark: row.remark || '' };
      this.dlg = true;
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate());
    },
    resetForm() { this.form = this.emptyForm(); if (this.$refs.formRef) this.$refs.formRef.resetFields(); },
    beforeImageUpload(file) {
      const ok = file.type.startsWith('image/') && file.size / 1024 / 1024 < 5;
      if (!file.type.startsWith('image/')) this.$message.error('请上传图片文件');
      if (file.size / 1024 / 1024 >= 5) this.$message.error('图片不能超过 5MB');
      return ok;
    },
    onImageSuccess(res) {
      const data = res && res.data;
      const path = data && (data.path || data.url || data.fileID || data.fileUrl);
      if (!path) return this.$message.error('上传失败');
      this.form.imageUrl = path;
      this.$refs.formRef && this.$refs.formRef.validateField('imageUrl');
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        const payload = { title: this.form.title.trim(), imageUrl: this.form.imageUrl, jumpUrl: this.form.jumpUrl || null, sortOrder: this.form.sortOrder, status: this.form.status, remark: this.form.remark || null };
        const request = this.dlgMode === 'create' ? http.post('/admin/banners', payload) : http.put(`/admin/banners/${this.form.id}`, payload);
        request.then(() => { this.$message.success('保存成功'); this.dlg = false; this.load(); }).catch((e) => this.$message.error(e.message || '保存失败')).finally(() => { this.saving = false; });
      });
    },
    toggleStatus(row) {
      const next = row.status === 1 ? 0 : 1;
      this.$confirm(`确定${next === 1 ? '启用' : '禁用'}该轮播图？`, '提示', { type: 'warning' }).then(() => http.patch(`/admin/banners/${row.id}/status`, { status: next })).then(() => { this.$message.success('已更新'); this.load(); }).catch(() => {});
    },
    remove(row) {
      this.$confirm(`确定删除轮播图「${row.title}」？`, '提示', { type: 'warning' }).then(() => http.delete(`/admin/banners/${row.id}`)).then(() => { this.$message.success('已删除'); this.load(); }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.toolbar { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.thumb { width: 128px; height: 64px; border-radius: 4px; }
.danger { color: #f56c6c; }
.hint { margin: 6px 0 0; font-size: 12px; color: #909399; }
.uploader >>> .el-upload { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; overflow: hidden; }
.uploader-icon { font-size: 28px; color: #8c939d; width: 240px; height: 120px; line-height: 120px; text-align: center; display: block; }
.preview { width: 240px; height: 120px; object-fit: cover; display: block; }
</style>
